interface WelcomeProps {
  title: string;
}

export function Welcome({ title }: WelcomeProps) {
  return (
    <section className="py-8 md:py-12 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-normal text-neutral-dark">
          {title}
        </h1>
      </div>
    </section>
  );
}